import styled, { css } from "styled-components";

const Tag = styled.span<{ $strong?: boolean }>`
  flex-shrink: 0;
  padding: 0.125rem 0.5rem;
  font-family: Inter, sans-serif;
  font-size: 0.625rem;
  font-weight: 800;
  line-height: 0.875rem;
  color: var(--color-brand-plus);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
  background: rgba(87, 242, 139, 0.15);
  border-radius: 100px;
  box-shadow: inset 0 0 0 1px rgba(87, 242, 139, 0.4);

  ${props =>
    props.$strong &&
    css`
      color: var(--color-neutral-darkness);
      background: var(--color-brand-plus);
      box-shadow: none;
    `}
`;

type Props = {
  children?: React.ReactNode;
  /** Solid green variant, for places that must stand out (e.g. the PLUS review loop). */
  strong?: boolean;
  className?: string;
};

/** Green "✦ PLUS" tag used to mark PLUS features across the panel. */
export const PlusTag = ({ children = "✦ Plus", strong, className }: Props) => (
  <Tag $strong={strong} className={className}>
    {children}
  </Tag>
);

/* Same shape and size as the PLUS tag, in grey: a FREE Keepo */
const Free = styled(Tag)`
  color: var(--color-neutral-150);
  background: rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.18);
`;

export const FreeTag = ({ children = "Free", className }: { children?: React.ReactNode; className?: string }) => (
  <Free className={className}>{children}</Free>
);
